export const DATENSCHUTZ_LINK_JOBS = '/jobs/privacy-policy';
